import { useState } from "react"
import {
    Layout,
    Menu,
} from "antd"
import {
    DownloadOutlined,
    BellOutlined,
    CheckCircleOutlined,
    SyncOutlined,
    SettingOutlined,
    KeyOutlined,
    LinkOutlined,
    CreditCardOutlined,
    LockOutlined,
    QuestionCircleOutlined,
    FileTextOutlined,
    UserOutlined,
} from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import logo from "../../assets/images/radarlogo.png";
import ThresholdControls from "./components/ThresholdControls";
import ExecutionControl from "./components/ExecutionControl";
import Notifications from "./components/Notifications";
import AuditLog from "./components/AuditLog";
import AccessRoles from "./components/AccessRoles";
import Integrations from "./components/Integrations";
import SystemStatus from "./components/SystemStatus";
import APIWebhooks from "./components/APIWebhooks";
import BillingSubscription from "./components/BillingSubscription";
import SecurityAccess from "./components/SecurityAccess";
import HelpSupport from "./components/HelpSupport";
import BackupExport from "./components/BackupExport";

const { Content, Sider } = Layout


export default function SettingsPage() {
    const navigate = useNavigate();

    const [selectedKey, setSelectedKey] = useState("1")
    const [collapsed, setCollapsed] = useState(false);
    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };
    const renderContent = () => {
        switch (selectedKey) {
            case "1":
                return <ThresholdControls />
            case "2":
                return <ExecutionControl />
            case "3":
                return <Notifications />
            case "4":
                return <AuditLog />
            case "5":
                return <AccessRoles />
            case "6":
                return <Integrations />
            case "7":
                return <SystemStatus />
            case "8":
                return <BackupExport />
            case "9":
                return <APIWebhooks />
            case "10":
                return <BillingSubscription />
            case "11":
                return <SecurityAccess />
            case "12":
                return <HelpSupport />
            default:
                return <ThresholdControls />
        }
    }

    return (
        <Layout style={{ height: "100vh" }}>
            <Sider 
                theme={"light"} 
                collapsible
                collapsed={collapsed}
                onCollapse={toggleCollapse}
                width={collapsed ? 80 : 230} 
            >
                <div className="p-4 cursor-pointer bg-white">
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ height: collapsed ? "10px" : "24px", filter: 'invert(1)' }}
                        onClick={() => navigate("/home")}
                    />
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    onClick={({ key }) => setSelectedKey(key)}
                    className=""
                    style={{ height: '80vh', overflow: 'hidden', overflowY: 'auto', borderRight: 0 }}
                    items={[
                        { key: "1", icon: <SettingOutlined />, label: "Threshold Controls" },
                        { key: "2", icon: <SyncOutlined />, label: "Execution Control" },
                        { key: "3", icon: <BellOutlined />, label: "Notifications" },
                        { key: "4", icon: <FileTextOutlined />, label: "Audit Log" },
                        { key: "5", icon: <UserOutlined />, label: "Access & Roles" },
                        { key: "6", icon: <LinkOutlined />, label: "Integrations" },
                        { key: "7", icon: <CheckCircleOutlined />, label: "System Status" },
                        { key: "8", icon: <DownloadOutlined />, label: "Backup & Export" },
                        { key: "9", icon: <KeyOutlined />, label: "API & Webhooks" },
                        { key: "10", icon: <CreditCardOutlined />, label: "Billing & Subscription" },
                        { key: "11", icon: <LockOutlined />, label: "Security & Access" },
                        { key: "12", icon: <QuestionCircleOutlined />, label: "Help & Support" },
                    ]}
                />
            </Sider>
            <Layout>
                <Content
                    style={{
                        padding: 24,
                        margin: 0,
                        height: '100vh',
                        overflow: 'hidden',
                        overflowY: 'auto'
                    }}
                >
                    {renderContent()}
                </Content>
            </Layout>
        </Layout>
    )
}
